<template>
  <v-dialog v-model="valid" max-width="900px">
    <v-card>
      <v-card-title>
        <span class="headline">Whatsapp Mesajı İçeriği Oluşturma</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="prepare" lazy-validation>
            <v-row>
              <v-flex xs12 md4>
                <v-flex xs12 class="pb-0">
                  <senders
                    label="Gönderici Adları"
                    required
                    :default="prepareWhatsapp.sender"
                    :rules="[$rules.selection('Gönderici Adları')]"
                    :items="data.senders"
                    @on:model-update="
                      (val) => {
                        prepareWhatsapp.sender = val;
                      }
                    "
                  >
                  </senders>
                </v-flex>
                <v-flex xs12 class="pt-0 pb-0">
                  <template-selector
                    label="Şablon Seçinizi"
                    :items="data.templates"
                    @on:template-selected="
                      (val) => {
                        msgBox = val.content;
                      }
                    "
                  >
                  </template-selector>
                </v-flex>
                <v-flex xs12>
                  <!-- DELAY SEÇENEĞİ -->
                  <v-select
                      v-model="prepareWhatsapp.delay"
                      :items="delayOptions"
                      label="Gönderim Hızı"
                      required
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-file-input
                      label="Whatsapp mesajına dosya ekleyebilirsiniz."
                      placeholder="Whatsapp mesajına eklemek istediğiniz dosyayı seçiniz."
                      v-model="prepareWhatsapp.attachment"
                      prepend-icon=""
                      validate-on-blur
                      @change="handleAttachmentChange"
                  >
                  </v-file-input>
                </v-flex>
                <v-flex xs12  v-if="previewUrl">
                  <img :src="previewUrl" alt="Preview" v-if="isImage" style="max-width: 25%;" />
                </v-flex>
              </v-flex>
              <v-flex xs12 md8>
                <v-col cols="12" v-if="data.keys">
                  <button-keys
                    :keys="data.keys"
                    item-value="value"
                    @on:button-key="
                      (val) => {
                        msgBox += ` ${val}`;
                      }
                    "
                  >
                  </button-keys>
                </v-col>
                <v-col cols="12">
                  <whatsapp-message
                    label="Mesajınız"
                    required
                    :rules="[
                            $rules.empty('Mesaj'),
                            (v) =>{
                              // eslint-disable-next-line max-len
                              return v.length + messageHolder.length >= 2000 ? 'Maksimum karakter sayısı 2000 olabilir.' : true
                              }
                          ]"
                    :value="msgBox"
                    :rows="7"
                    :cMessage="msgBox + messageHolder"
                    @button:status="(val) => buttonStatus = val"
                    @text:change="
                      (val) => {
                        msgBox = val;
                      }
                    "
                  >
                  </whatsapp-message>
                </v-col>
              </v-flex>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="$emit('on:close')"
          >Kapat ve Devam et</v-btn
        >
        <whatsapp-confirmation
          :context="confirmation.context"
          :valid="confirmation.valid"
          @on:disagree="
            () => {
              $trigger('setPluginDialog');
              $emit('update:confirmation', !confirmation.valid);
              // confirmation.valid = !confirmation.valid;
            }
          "
          @on:agree="prepareButton"
        >
          <template v-slot:activator>
            <v-btn color="blue darken-1" text @click="previewButton" :disabled="buttonStatus === 'disabled' ? true : false"
              >Gönder</v-btn
            >
          </template>
        </whatsapp-confirmation>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import checkWebsite from '@/mixins/computed/check-website';
import { types } from '../../../misc';
import Senders from '../WhatsappConstants/Senders.vue';
import ButtonKeys from '../WhatsappConstants/ButtonKeys.vue';
import TemplateSelector from '../WhatsappConstants/TemplateSelector.vue';
import WhatsappMessage from '../WhatsappConstants/WhatsappMessage.vue';
import WhatsappConfirmation from '../WhatsappConfirmation.vue';

export default {
  name: 'WhatsappPrepare',
  components: {
    WhatsappConfirmation,
    WhatsappMessage,
    TemplateSelector,
    ButtonKeys,
    Senders,
  },
  data: () => ({
    types,
    txt: '',
    dateSelected: false,
    prepareWhatsapp: {
      attachment: [],
      sender: '',
      delay: null,
    },
    delayOptions: [
    { text: 'Çok Hızlı (5 saniye de bir)', value: 1 },
      { text: 'Hızlı (10 saniye de bir)', value: 2 },
      { text: 'Orta (20 saniye de bir)', value: 3 },
      { text: 'Yavaş (35 saniye de bir)', value: 4 },
    ],
    attachment: [],
    previewUrl: null,
    attachmentName: null,
    isImage: false,
    defaultMessage: '',
    defaultLink: '/v/f58d59',
    messageHolder: '',
    buttonStatus: '',
  }),
  props: {
    valid: {
      type: Boolean,
    },
    confirmation: {},
    data: {},
  },
  methods: {
    ...mapActions({ send: 'sendBackend' }),
    handleAttachmentChange() {
      const file = this.prepareWhatsapp.attachment;

      if (file) {
        this.isImage = file.type.startsWith('image/');
        this.previewUrl = this.isImage ? URL.createObjectURL(file) : null;
        this.fileName = file.name;
      } else {
        this.previewUrl = null;
        this.fileName = null;
        this.isImage = false;
      }
    },
    setInitialStates() {
      this.prepareWhatsapp.attachment = this.attachment;
      this.prepareWhatsapp.delay = this.delay;
      this.prepareWhatsapp.sender = this.data.senders[0];
    },
    prepareLocals() {
      this.prepareWhatsapp.message = this.msgBox;
      this.prepareWhatsapp.attachment = this.attachment;
      this.prepareWhatsapp.delay = this.delay;
      this.prepareWhatsapp.sender = this.prepareWhatsapp.sender;
    },
    preparePreviews() {
      this.prepareWhatsapp.message = this.msgBox;
      this.prepareWhatsapp.attachment = this.attachment.name;
      this.prepareWhatsapp.delay = this.delay;
      this.prepareWhatsapp.sender = this.prepareWhatsapp.sender;
    },
    prepareButton() {
      this.$emit('update:confirmation', this.$refs.prepare.validate());
      this.prepareLocals();
      const data = {
        ...this.prepareWhatsapp,
      };
      if (this.$refs.prepare.validate()) {
        this.$emit('on:send', data);
        this.$emit('on:close');
      }
    },
    previewButton() {
      this.preparePreviews();
      this.$emit('update:confirmation', this.$refs.prepare.validate());

      if (this.$refs.prepare.validate()) {
        const data = {
          ...this.prepareWhatsapp,
        };
        this.$emit('on:preview', data);
      }
    },
  },
  created() {
    this.defaultLink = (this.isVatan
        ? 'vatansms.net'
        : 'toplusmspaketleri.com') + this.defaultLink;
    this.prepareWhatsapp.bridge = this.isVatan
      ? 'vatansms.net'
      : 'toplusmspaketleri.com';
    this.delay = this.delayOptions.find(option => option.text === 'Çok Hızlı (5 saniye de bir)').value;
  },
  computed: {
    msgBox: {
      get() {
        return this.txt || '';
      },
      set(v) {
        this.txt = v;
      },
    },
  },

  watch: {
    data(nv) {
      if (
          this.prepareWhatsapp.sender !== ''
      ) {
        this.prepareWhatsapp.sender = nv.senders[0];
      }
    },
  },

  events: {
    setInitials: 'setInitialStates',
  },
};
</script>
